export const CHANGE_FONT = "CHANGE_FONT";
export const DISABLE_KEY_DOWN = "DISABLE_KEY_DOWN";
export const FONT_HEADING_LOCK = "FONT_HEADING_LOCK";
export const FONT_DESCRIPTION_LOCK = "FONT_DESCRIPTION_LOCK";
export const GET_FONT = "GET_FONT";
export const GET_FONT_PAIRS = "GET_FONT_PAIRS";
export const IS_FONT_LOADING = "IS_FONT_LOADING";
